module.exports = __webpack_public_path__ + "img/927-57c028.png";